import { render, staticRenderFns } from "./PdpBespokeCustomization.vue?vue&type=template&id=a49e4a46&scoped=true&"
import script from "./PdpBespokeCustomization.vue?vue&type=script&lang=js&"
export * from "./PdpBespokeCustomization.vue?vue&type=script&lang=js&"
import style0 from "./PdpBespokeCustomization.vue?vue&type=style&index=0&id=a49e4a46&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49e4a46",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppCheckbox: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppCheckbox.vue').default})
